import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import { debounce } from 'lodash';
export default {
  name: 'LicenseNumberDialog',
  mixins: [dialog],
  props: {
    licensesNumber: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    max: {
      type: Number,
      default: function _default() {
        return null;
      }
    },
    min: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    update: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      licenses: 1,
      loadingNextInvoice: false,
      nextInvoice: null
    };
  },
  methods: {
    selectLicenses: function selectLicenses() {
      this.onComplete(this.licenses);
      this.hide();
    },
    increaseLicenses: function increaseLicenses() {
      if (this.disableAdd) return;
      this.licenses++;

      if (this.update && this.me.account.payment_processor === 'stripe') {
        this.loadingNextInvoice = true;
        this.fetchUpcomingInvoice();
      }
    },
    decreaseLicenses: function decreaseLicenses() {
      if (this.disableRemove) return;
      this.licenses--;

      if (this.update && this.me.account.payment_processor === 'stripe') {
        this.loadingNextInvoice = true;
        this.fetchUpcomingInvoice();
      }
    },
    fetchUpcomingInvoice: debounce(function () {
      var _this = this;

      this.$axios.get('/invoices/next?quantity=' + this.licenses).then(function (response) {
        _this.nextInvoice = response.data;
      }).finally(function () {
        _this.loadingNextInvoice = false;
      });
    }, 300)
  },
  computed: {
    disableAdd: function disableAdd() {
      return !!(this.max && this.licenses >= this.max);
    },
    disableRemove: function disableRemove() {
      return !!(this.licenses === this.min);
    },
    period: function period() {
      if (!this.nextInvoice) return ''; // Get the first line item of the invoice

      var lineItem = this.nextInvoice.lines.data[0];
      if (!lineItem) return '';
      var plan = lineItem.plan;
      if (!plan) return '';

      switch (plan.interval) {
        case 'month':
          return this.$t('pages.billing.monthly_duration');

        case 'year':
          return this.$t('pages.billing.yearly_duration');

        default:
          return '';
      }
    },
    amountDue: function amountDue() {
      if (!this.nextInvoice) return '';
      return this.nextInvoice.amount_due / 100;
    },
    newRecurrentAmount: function newRecurrentAmount() {
      if (!this.nextInvoice) return ''; // Get the first line item of the invoice

      var lineItem = this.nextInvoice.lines.data[0];
      if (!lineItem) return '';
      var plan = lineItem.plan;
      if (!plan) return '';
      return plan.amount * this.licenses / 100;
    },
    currency: function currency() {
      if (!this.nextInvoice) return '';
      return this.nextInvoice.currency.toUpperCase();
    }
  },
  components: {
    TeDialog: TeDialog
  },
  mounted: function mounted() {
    this.licenses = this.licensesNumber;
  }
};